import request from "@/services/api/request";

const recordings = {
  service() {
    return {
      list(params) {
        return request.get("/interviews-api/recordings", params);
      },
      download(url) {
        return request.getRemoteBlob(url);
      },
    };
  },
};

export default recordings;
